<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- 戻る -->
    <div class="return">
      <button pButton type="button" label="マイページ" class="p-button-text" (click)="moveB301()"></button>
      <button pButton type="button" label="　事務局メニュー" class="p-button-text" (click)="moveD101()"
        icon="pi pi-angle-left"></button>
      <button pButton type="button" label="　ダッシュボード" class="p-button-text" icon="pi pi-angle-left"></button>
    </div>
    <!-- タイトル -->
    <div class="dashboard-title">

      <!-- タイトルコンテンツ -->
      <div class="title-content">
        <!-- タイトル -->
        <div class="p-d-flex p-jc-center title">
          ダッシュボード
        </div>
      </div>
    </div>
    <!-- ダッシュボード -->
    <div class="dashboard-content">
      <!-- 説明リンク -->
      <div>
        <label class="text-link" onclick="window.open('./data/dashboard_manual.pdf')"><u>詳細説明はこちら</u></label>
      </div>
      <p-tabView>
        <p-tabPanel class="member-tabpanel" [header]="'会員分析'" [selected]="true">
          <!-- 検索条件入力 -->
          <div class="search-form-area search-form-area-i101">
            <form [formGroup]="i101SearchFormMember" (ngSubmit)="getResultDataList('member')">
              <!-- 検索条件 -->
              <div class="p-d-flex p-jc-between item-div">
                <div class="p-d-flex p-jc-left">
                  <!-- サブタイトル -->
                  <h2>Summary</h2>
                  <!-- 検索テキスト -->
                  <!-- 更新日時 -->
                  <div class="item-flex">
                    <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                      pTooltip="Summary明細ZIP" tooltipPosition="bottom" (click)="exportZIP(0)"></button>
                    <label class="space"></label>
                    <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                      pTooltip="Summary集計ZIP" tooltipPosition="bottom" (click)="exportZIP_totalCSV(0)"></button>
                    <label class="space"></label>
                    <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true" [monthNavigator]="true"
                      placeholder="例）2021/07" dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                      yearRange="2000:2999" formControlName="date1" translate></p-calendar>
                    <div class="verticalTilde">〜</div>
                    <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true" [monthNavigator]="true"
                      placeholder="例）2021/07" dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                      yearRange="2000:2999" formControlName="date2" translate></p-calendar>
                    <label class="space"></label>
                    <label class="space"></label>
                    <button pButton type="button" label="検索" class="button1 search-button"
                      (click)="getResultDataList('member')"></button>
                    <label class="space"></label>
                    <label class="space"></label>
                    <button pButton type="button" label="検索条件をクリアする" class="button-size button2"
                      (click)="clearConditions()"></button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- サマリー -->
          <div class="summary-content">
            <!-- 会員数 -->
            <span class="panel">
              <div class="title-panel">
                <h3>
                  会員数
                  <!-- <i class="pi pi-info-circle tooltip" tooltipStyleClass="information" tooltipPosition="top" fitContent="true"
                    pTooltip="登録する事例に関する画像を、PNG/JPEG/JPG(最大5MB)のいずれかの形式で、ファイルをアップロードしてください。"> -->
                </h3>
              </div>
              <div class="detail-panel">
                <div class="detail">
                  <p>1号会員</p>
                  <p>{{ getBindValue(summary1DataList, 0, "member_count", 0, "class_id_1") }}</p>
                </div>
                <div class="detail">
                  <p>2号会員</p>
                  <p>{{ getBindValue(summary1DataList, 0, "member_count", 1, "class_id_2") }}</p>
                </div>
                <div class="detail">
                  <p>3号会員</p>
                  <p>{{ getBindValue(summary1DataList, 0, "member_count", 2, "class_id_3") }}</p>
                </div>
              </div>
            </span>
            <!-- ID/PWD設定率 -->
            <span class="panel">
              <h3>
                ID/PWD設定率
              </h3>
              <div class="detail-panel">
                <div class="detail">
                  <p>1号会員</p>
                  <p>{{ getBindValue(summary1DataList, 1, "id_pass_ratio", 0, "class_id_1") }}%</p>
                </div>
                <div class="detail">
                  <p>2号会員</p>
                  <p>{{ getBindValue(summary1DataList, 1, "id_pass_ratio", 1, "class_id_2") }}%</p>
                </div>
                <div class="detail">
                  <p>3号会員</p>
                  <p>{{ getBindValue(summary1DataList, 1, "id_pass_ratio", 2, "class_id_3") }}%</p>
                </div>
              </div>
            </span>
            <!-- ログイン率 -->
            <span class="panel">
              <h3>
                ログイン率
              </h3>
              <div class="detail-panel">
                <div class="detail">
                  <p>1号会員</p>
                  <p>{{ getBindValue(summary1DataList, 2, "login_ratio", 0, "class_id_1") }}%</p>
                </div>
                <div class="detail">
                  <p>2号会員</p>
                  <p>{{ getBindValue(summary1DataList, 2, "login_ratio", 1, "class_id_2") }}%</p>
                </div>
                <div class="detail">
                  <p>3号会員</p>
                  <p>{{ getBindValue(summary1DataList, 2, "login_ratio", 2, "class_id_3") }}%</p>
                </div>
              </div>
            </span>
            <!-- 累計課題登録団体数 -->
            <span class="panel">
              <h3>
                課題登録団体数（累計）
              </h3>
              <div class="detail-panel">
                <div class="detail">
                  <p>1号会員</p>
                  <p>{{ getBindValue(summary1DataList, 3, "agenda_count", 0, "class_id_1") }}</p>
                </div>
                <div class="detail">
                  <p>2号会員</p>
                  <p>{{ getBindValue(summary1DataList, 3, "agenda_count", 1, "class_id_2") }}</p>
                </div>
                <div class="detail">
                  <p>3号会員</p>
                  <p>{{ getBindValue(summary1DataList, 3, "agenda_count", 2, "class_id_3") }}</p>
                </div>
              </div>
            </span>
          </div>
          <!-- ダッシュボード表示 -->
          <div class="dashboard-area">
            <!-- 会員数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>会員数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download" pTooltip="会員数明細CSV"
                    tooltipPosition="bottom" (click)="exportCSV_STATEMACHINE('member_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download" pTooltip="会員数集計CSV"
                    tooltipPosition="bottom" (click)="exportCSV('member_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="line" height="400px" [data]="memberCountDataList" [options]="memberChartOptions">
                </p-chart>
              </div>
            </div>
            <!-- ID/PWD設定済U団体数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>ID/PWD設定済U団体数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="ID/PWD設定済U団体数明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('pwdSettingCompleteU_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="ID/PWD設定済U団体数集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('pwdSettingCompleteU_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="line" height="400px" [data]="pwdSettingCompleteUDataList" [options]="memberChartOptions">
                </p-chart>
              </div>
            </div>
            <!-- ID/PWD設定済UU数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>ID/PWD設定済UU数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="ID/PWD設定済UU数明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('pwdSettingCompleteUU_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="ID/PWD設定済UU数集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('pwdSettingCompleteUU_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="line" height="400px" [data]="pwdSettingCompleteUUDataList"
                  [options]="memberChartOptions">
                </p-chart>
              </div>
            </div>
            <!-- 月間ログインU団体数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>月間ログインU団体数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="月間ログインU団体数明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('monthLoginOrganizationU_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="月間ログインU団体数集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('monthLoginOrganizationU_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="monthLoginOrganizationUDataList"
                  [options]="memberChartOptions"></p-chart>
              </div>
            </div>
            <!-- 月間ログインUU数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>月間ログインUU数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="月間ログインUU数明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('monthLoginOrganizationUU_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="月間ログインUU数集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('monthLoginOrganizationUU_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="monthLoginOrganizationUUDataList"
                  [options]="memberChartOptions"></p-chart>
              </div>
            </div>
            <!-- 課題登録団体数（累計） -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>課題登録団体数（累計）</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="課題登録団体数（累計）明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('agendaRegistOrganization_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="課題登録団体数（累計）集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('agendaRegistOrganization_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="agendaRegistOganizationCountDataList"
                  [options]="memberChartOptions"></p-chart>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel class="matching-tabpanel" [header]="'マッチングボトルネック分析'">
          <!-- 検索条件入力 -->
          <div class="search-form-area search-form-area-i101">
            <form [formGroup]="i101SearchFormMatching" (ngSubmit)="getResultDataList('matching')">
              <!-- 検索条件 -->
              <div class="p-d-flex p-jc-between item-div">
                <div class="p-d-flex p-jc-left">
                  <!-- サブタイトル -->
                  <h2>Summary</h2>
                  <!-- 検索テキスト -->
                  <!-- 更新日時 -->
                  <div class="item-flex">
                    <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                      pTooltip="Summary明細ZIP" tooltipPosition="bottom" (click)="exportZIP(1)"></button>
                    <label class="space"></label>
                    <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                      pTooltip="Summary集計ZIP" tooltipPosition="bottom" (click)="exportZIP_totalCSV(1)"></button>
                    <label class="space"></label>
                    <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true" [monthNavigator]="true"
                      placeholder="例）2021/07" dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                      yearRange="2000:2999" formControlName="date1" translate></p-calendar>
                    <div class="verticalTilde">〜</div>
                    <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true" [monthNavigator]="true"
                      placeholder="例）2021/07" dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                      yearRange="2000:2999" formControlName="date2" translate></p-calendar>
                    <label class="space"></label>
                    <label class="space"></label>
                    <button pButton type="button" label="検索" class="button1 search-button"
                      (click)="getResultDataList('matching')"></button>

                    <label class="space"></label>
                    <label class="space"></label>
                    <button pButton type="button" label="検索条件をクリアする" class="button-size button2"
                      (click)="clearConditions()"></button>

                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- サマリー -->
          <div class="summary-content">
            <!-- 課題登録件数 -->
            <span class="panel">
              <div class="title-panel">
                <h3>
                  課題登録件数
                </h3>
              </div>
              <div class="detail-panel">
                <div class="detail">
                  <p>累計</p>
                  <p>{{ getBindValue(summary2DataList, 0, "agenda_count", 0, "sum") }}</p>
                </div>
                <div class="detail">
                  <p>新規登録</p>
                  <p>+{{ getBindValue(summary2DataList, 0, "agenda_count", 0, "new") }}</p>
                </div>
              </div>
            </span>
            <!-- ｿﾘｭｰｼｮﾝ登録件数 -->
            <span class="panel">
              <h3>
                ｿﾘｭｰｼｮﾝ登録件数
              </h3>
              <div class="detail-panel">
                <div class="detail">
                  <p>累計</p>
                  <p>{{ getBindValue(summary2DataList, 1, "solution_count", 0, "sum") }}</p>
                </div>
                <div class="detail">
                  <p>新規登録</p>
                  <p>+{{ getBindValue(summary2DataList, 1, "solution_count", 0, "new") }}</p>
                </div>
              </div>
            </span>
            <!-- 提案登録件数 -->
            <span class="panel">
              <h3>
                提案登録件数
              </h3>
              <div class="detail-panel">
                <div class="detail">
                  <p>累計</p>
                  <p>{{ getBindValue(summary2DataList, 2, "suggest_count", 0, "sum") }}</p>
                </div>
                <div class="detail">
                  <p>新規登録</p>
                  <p>+{{ getBindValue(summary2DataList, 2, "suggest_count", 0, "new") }}</p>
                </div>
              </div>
            </span>
            <!-- 意見交換希望件数 -->
            <span class="panel">
              <h3>
                意見交換希望件数
              </h3>
              <div class="detail-panel">
                <div class="detail">
                  <p>累計</p>
                  <p>{{ getBindValue(summary2DataList, 3, "match_count", 0, "sum") }}</p>
                </div>
                <div class="detail">
                  <p>新規登録</p>
                  <p>+{{ getBindValue(summary2DataList, 3, "match_count", 0, "new") }}</p>
                </div>
              </div>
            </span>
            <!-- 連携開始件数 -->
            <span class="panel">
              <h3>
                連携開始件数
              </h3>
              <div class="detail-panel">
                <div class="detail">
                  <p>累計</p>
                  <p>{{ getBindValue(summary2DataList, 4, "coop_count", 0, "sum") }}</p>
                </div>
                <div class="detail">
                  <p>新規登録</p>
                  <p>+{{ getBindValue(summary2DataList, 4, "coop_count", 0, "new") }}</p>
                </div>
              </div>
            </span>
          </div>
          <!-- ダッシュボード表示 -->
          <div class="dashboard-area">
            <!-- 課題登録件数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>課題登録件数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="課題登録件数明細CSV" tooltipPosition="bottom" (click)="exportCSV_STATEMACHINE('agendaRegist_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="課題登録件数集計CSV" tooltipPosition="bottom" (click)="exportCSV('agendaRegist_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="agendaRegistCountDataList" [options]="matchingChartOptions">
                </p-chart>
              </div>
            </div>
            <!-- ｿﾘｭｰｼｮﾝ登録件数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>ｿﾘｭｰｼｮﾝ登録件数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="ｿﾘｭｰｼｮﾝ登録件数明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('solutionRegist_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="ｿﾘｭｰｼｮﾝ登録件数集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('solutionRegist_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="solutionRegistCountDataList"
                  [options]="matchingChartOptions">
                </p-chart>
              </div>
            </div>
            <!-- 提案登録件数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>提案登録件数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="提案登録件数明細CSV" tooltipPosition="bottom" (click)="exportCSV_STATEMACHINE('suggestRegist_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="提案登録件数集計CSV" tooltipPosition="bottom" (click)="exportCSV('suggestRegist_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="suggestRegistCountDataList" [options]="matchingChartOptions">
                </p-chart>
              </div>
            </div>
            <!-- 意見交換希望件数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>意見交換希望件数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="意見交換希望件数明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('opinionExchange_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="意見交換希望件数集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('opinionExchange_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="opinionExchangeDesiredCountDataList"
                  [options]="matchingChartOptions"></p-chart>
              </div>
            </div>
            <!-- 連携開始件数 -->
            <div class="dashboard-panel clearfix">
              <!-- サブタイトル -->
              <div class="sub-title">
                <div class="sub-item p-d-flex p-jc-left">
                  <h2>連携開始件数</h2>
                  <button pButton type="button" label="明細" class="csv-button" icon="pi pi-download"
                    pTooltip="連携開始件数明細CSV" tooltipPosition="bottom"
                    (click)="exportCSV_STATEMACHINE('cooperation_start_count')"></button>
                  <label class="space"></label>
                  <button pButton type="button" label="集計" class="csv-button" icon="pi pi-download"
                    pTooltip="連携開始件数集計CSV" tooltipPosition="bottom"
                    (click)="exportCSV('cooperation_start_total')"></button>
                </div>
              </div>
              <!-- ダッシュボード -->
              <div class="dashboard-div clearfix">
                <p-chart type="bar" height="400px" [data]="coordinationStartCountDataList"
                  [options]="matchingChartOptions">
                </p-chart>
              </div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>